import type { LogItemType } from "@/types/common/logs";

const SUSPENSION_EXTENSION_EVENTS = new Set<string>([
  "node_time_extension_request",
  "node_deadline_suspension_request",
  "suspension_request_created_external",
  "suspension_request_created_internal",
  "suspension_request_approved",
  "suspension_request_denied",
  "suspension_request_scaled",
  "suspension_request_analyst_approved",
  "suspension_request_analyst_denied",
  "suspension_request_leader_approved",
  "suspension_request_leader_denied",
  "extension_request_created",
  "extension_request_approved",
  "extension_request_denied",
  "extension_request_scaled",
  "extension_request_analyst_approved",
  "extension_request_analyst_denied",
  "extension_request_leader_approved",
  "extension_request_leader_denied",
]);

export function isSuspensionExtensionLog(log: LogItemType): boolean {
  const normalizedEvent = (log.event || log.properties?.action || "")
    .toLowerCase()
    .trim();

  return !!(
    normalizedEvent && SUSPENSION_EXTENSION_EVENTS.has(normalizedEvent)
  );
}
